//#region src/components/Tree/helpers/isMatchDefault.ts
var e = (e, t) => {
	let n = t.trim().toLowerCase();
	return e.title.toLowerCase().includes(n);
};
//#endregion
export { e as isMatchDefault };
